import qz from 'qz-tray';
import { toast } from 'react-toastify';
import { getCertificate, getSignature } from 'src/api/qz_tray';
import i18n from 'src/locales/i18n';

i18n.loadNamespaces(['qz_tray']);

let qzReady = null;
let isConfigured = false;
const statusListeners = new Set();

const notifyStatus = (status) => {
  statusListeners.forEach((listener) => listener(status));
};

export const subscribeQzStatus = (listener) => {
  statusListeners.add(listener);
  return () => statusListeners.delete(listener);
};

const startConnection = () => {
  if (qzReady) {
    return qzReady;
  }
  if (qz.websocket.isActive()) {
    qzReady = Promise.resolve();
    return qzReady;
  }

  const config = { retries: 5, delay: 1 };
  qzReady = qz.websocket
    .connect(config)
    .then(() => {
      notifyStatus('open');
    })
    .catch((error) => {
      qzReady = null;
      toast.error(i18n.t('qz_tray:lna_error_message'), { autoClose: 8000 });
      throw error;
    });

  return qzReady;
};

export const getQzReady = () => startConnection();

export const initializeQzTray = () => {
  try {
    if (!isConfigured) {
      qz.security.setCertificatePromise(function (resolve, reject) {
        getCertificate()
          .then((data) => {
            const signedCertificate = data.searchResults;
            if (!signedCertificate.length) {
              throw new Error('No certificate received');
            }
            resolve(signedCertificate);
          })
          .catch((error) => {
            reject(error.message);
          });
      });
      qz.security.setSignatureAlgorithm('SHA512');
      qz.security.setSignaturePromise(function (toSign) {
        return async function (resolve, reject) {
          try {
            const response = await getSignature(toSign);
            resolve(response);
          } catch (error) {
            reject(error.message);
          }
        };
      });

      qz.websocket.setClosedCallbacks(() => {
        qzReady = null;
        notifyStatus('closed');
      });
      qz.websocket.setErrorCallbacks(() => {
        qzReady = null;
        notifyStatus('error');
      });

      isConfigured = true;
    }

    startConnection();
  } catch (e) {
    alert(`Error: ${e.message}`);
  }
};
